import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=aa02664c"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa02664c')) {
      api.createRecord('aa02664c', component.options)
    } else {
      api.reload('aa02664c', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=aa02664c", function () {
      api.rerender('aa02664c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/pages/Register.vue"
export default component.exports